import { useEffect } from 'react';
import { getUserId } from './helpers/walletTransaction';
import WalletTransactionHeader from 'src/view/screens/WalletTransactionLogScreen/screens/WTLogScreen/containers/WTLogHeader/WTLogHeader';
import WalletTransactionList from 'src/view/screens/WalletTransactionLogScreen/screens/WTLogScreen/containers/WTLogList/WTLogList';
import walletTransactionStore from 'src/view/screens/WalletTransactionLogScreen/screens/WTLogScreen/store/walletTransactionStore';
import { SCREENS } from '~/constants/screens';
import Headers from 'src/view/containers/Headers/Headers';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';
import LogNavigation from '~/view/components/LogNavigation/LogNavigation';

const WTLogScreen = (): JSX.Element => {
  useEffect(() => {
    walletTransactionStore.fetchWalletTransactionList();

    return () => {
      walletTransactionStore.clear();
    };
  }, []);

  walletTransactionStore.filters.userId = getUserId();

  return (
    <>
      {walletTransactionStore.filters.userId ? (
        <>
          <Headers>
            <HeaderBack title="wallet_transaction_log" path={SCREENS.CRM_PROFILE_EDIT(walletTransactionStore.filters.userId)} />
          </Headers>
          <LogNavigation />
          <div className="mt-6"></div>
        </>
      ) : (
        <>
          <Headers>
            <HeaderBack title="wallet_transaction_log" path={SCREENS.REPORTS()} />
          </Headers>
          <LogNavigation />
          <div className="mt-6"></div>
        </>
      )}
      <WalletTransactionHeader />
      <WalletTransactionList />
    </>
  );
};

export default WTLogScreen;
